enum IntegrationSystem {
  Omnivore = 1,
  Olo = 6,
  Punchh = 8,
  Smg = 9,
  Salido = 10,
  /** @deprecated */
  BreadcrumbDeprecated = 13,
  Revel = 14,
  CardConnect = 15,
  Tcc = 16,
  PaytronixOlo = 17,
  SquarePos = 19,
  Worldpay = 20,
  QsrAutomations = 22,
  ParBrink = 23,
  PunchhOlo = 25,
  Givex = 26,
  SessionMOlo = 27,
  Toast = 28,
  Heartland = 29,
  Infor = 30,
  Archer = 31,
  AtriumStoredValue = 32,
  ParBrinkLoyaltyEarner = 33,
  PinataPos = 34,
  PinataLoyalty = 35,
  Stripe = 36,
  FreedomPayFlash = 37,
  Twilio = 38,
  PinataNotifier = 39,
  Como = 40,
  FreedomPayKiosk = 41,
  PinataStoredValue = 42,
  Valutec = 43,
  PaytronixGift = 44,
  NcrRadiant = 45,
  Vicki = 48,
  PaytronixLoyalty = 49,
  NcrAloha = 50,
  Elavon = 51,
  Incentivio = 52,
  Otter = 53,
  Sprinkles = 54,
  Simphony = 55,
  VerifonePointCloud = 56,
  LogicControls = 57,
  OloPayKioskOrderingApi = 58,
  PDI = 59,
  StripeTerminal = 60,
  Eigen = 61,
  Adyen = 62,
  SpotOn = 63,
  PinataFulfillment = 64,
  IQTouch = 65,
  ComoEarner = 66,
  VerifonePointSca = 67,
  Sparkfly = 68,
  WorldpayStoredValue = 69,
  OloStoredValue = 70,
  CheetahOloLoyalty = 71,
  Lunchbox = 72,
  FreshKDS = 73,
  ThanxOlo = 74,
  ComoOlo = 75,
  EigenStoredValue = 76,
  LoyaltyPlantEarner = 77,
  PaytronixCompCard = 78,
  PeetsPaytronixOlo = 79,
  ChoptLoyalty = 80,
  PinataCompCard = 81,
  PinataPay = 82,
  PinataPayStoredValue = 83,
  Attentive = 84,
  LovesRewards = 85,
  Qu = 86,
  FreedomPayKioskStoredValue = 87,
  PinataPayNative = 88,
  PinataPayNativeStoredValue = 89,
  CbordStoredValue = 90,
  LrsTableTracker = 91,
  OloPayKioskPaymentApi = 92,
  Thanx = 93,
  ParPay = 94,
  ParPayStoredValue = 95,
  AurusPay = 96,
  AurusPayStoredValue = 97,
  Chase = 98,
  ChaseStoredValue = 99,
  Deliverect = 100,
  SmoothCommerce = 101,
  Spendgo = 102,
  Vibes = 103,
  Moneris = 104,
  LoyaltyPlant = 105,
  StarbucksPayAndEarnLoyalty = 106,
  AtriumLoyalty = 108,
  StarbucksPos = 109,
  Jtech = 110,
  PinataTableTracker = 111,
  StarbucksFullLoyalty = 112,
  PinataCashMachine = 113,
  Glory = 114,
  LovesPos = 115,
  SparkflyLoyaltyEarner = 116,
  CbordCampusCard = 117,
  PinataCampusCard = 118,
  DeliverectCommerce = 119,
  ParPosDataSource = 120,
  VerifoneCommander = 121,
  QuickchargeCampusCard = 122,
  Qualtrics = 123,
  StarbucksStoredValue = 124,
}

namespace IntegrationSystem {
  export type CampusCard =
    | IntegrationSystem.CbordCampusCard
    | IntegrationSystem.PinataCampusCard
    | IntegrationSystem.QuickchargeCampusCard;

  export type CashMachine = IntegrationSystem.PinataCashMachine | IntegrationSystem.Glory;

  export type CompCard = IntegrationSystem.PaytronixCompCard | IntegrationSystem.PinataCompCard;

  export type EcommPayment = IntegrationSystem.FreedomPayFlash | IntegrationSystem.Stripe;

  export type EmailNotifier = never;

  export type Fulfillment =
    | IntegrationSystem.FreshKDS
    | IntegrationSystem.LogicControls
    | IntegrationSystem.PinataFulfillment
    | IntegrationSystem.QsrAutomations
    | IntegrationSystem.Vicki;

  export type KioskPayment =
    | IntegrationSystem.Adyen
    | IntegrationSystem.AurusPay
    | IntegrationSystem.CardConnect
    | IntegrationSystem.Chase
    | IntegrationSystem.Eigen
    | IntegrationSystem.Elavon
    | IntegrationSystem.FreedomPayKiosk
    | IntegrationSystem.Heartland
    | IntegrationSystem.Moneris
    | IntegrationSystem.OloPayKioskOrderingApi
    | IntegrationSystem.OloPayKioskPaymentApi
    | IntegrationSystem.ParPay
    | IntegrationSystem.PinataPay
    | IntegrationSystem.PinataPayNative
    | IntegrationSystem.StripeTerminal
    | IntegrationSystem.VerifonePointCloud
    | IntegrationSystem.VerifonePointSca
    | IntegrationSystem.Worldpay;

  export type KioskPos = IntegrationSystem.VerifoneCommander;

  export type Loyalty =
    | IntegrationSystem.AtriumLoyalty
    | IntegrationSystem.CheetahOloLoyalty
    | IntegrationSystem.ChoptLoyalty
    | IntegrationSystem.Como
    | IntegrationSystem.ComoOlo
    | IntegrationSystem.Incentivio
    | IntegrationSystem.LovesRewards
    | IntegrationSystem.LoyaltyPlant
    | IntegrationSystem.Lunchbox
    | IntegrationSystem.PaytronixLoyalty
    | IntegrationSystem.PaytronixOlo
    | IntegrationSystem.PeetsPaytronixOlo
    | IntegrationSystem.PinataLoyalty
    | IntegrationSystem.Punchh
    | IntegrationSystem.PunchhOlo
    | IntegrationSystem.SessionMOlo
    | IntegrationSystem.SmoothCommerce
    | IntegrationSystem.Sparkfly
    | IntegrationSystem.Spendgo
    | IntegrationSystem.StarbucksFullLoyalty
    | IntegrationSystem.StarbucksPayAndEarnLoyalty
    | IntegrationSystem.Thanx
    | IntegrationSystem.ThanxOlo;

  export type LoyaltyEarner =
    | IntegrationSystem.ComoEarner
    | IntegrationSystem.LoyaltyPlantEarner
    | IntegrationSystem.ParBrinkLoyaltyEarner
    | IntegrationSystem.SparkflyLoyaltyEarner;

  export type PunchhLoyalty = IntegrationSystem.Punchh | IntegrationSystem.PunchhOlo;

  export type Marketing =
    | IntegrationSystem.Attentive
    | IntegrationSystem.Smg
    | IntegrationSystem.Vibes
    | IntegrationSystem.Qualtrics;

  export type Pos =
    | IntegrationSystem.BreadcrumbDeprecated
    | IntegrationSystem.Deliverect
    | IntegrationSystem.DeliverectCommerce
    | IntegrationSystem.Infor
    | IntegrationSystem.IQTouch
    | IntegrationSystem.LovesPos
    | IntegrationSystem.NcrAloha
    | IntegrationSystem.NcrRadiant
    | IntegrationSystem.Olo
    | IntegrationSystem.Omnivore
    | IntegrationSystem.Otter
    | IntegrationSystem.ParBrink
    | IntegrationSystem.PDI
    | IntegrationSystem.PinataPos
    | IntegrationSystem.Qu
    | IntegrationSystem.Revel
    | IntegrationSystem.Salido
    | IntegrationSystem.Simphony
    | IntegrationSystem.SpotOn
    | IntegrationSystem.SquarePos
    | IntegrationSystem.StarbucksPos
    | IntegrationSystem.Toast
    | IntegrationSystem.VerifoneCommander;

  export type PosDataSource = IntegrationSystem.ParPosDataSource;

  export type SmsNotifier = IntegrationSystem.PinataNotifier | IntegrationSystem.Twilio;

  export type StoredValue =
    | IntegrationSystem.Archer
    | IntegrationSystem.AtriumStoredValue
    | IntegrationSystem.AurusPayStoredValue
    | IntegrationSystem.CbordStoredValue
    | IntegrationSystem.ChaseStoredValue
    | IntegrationSystem.EigenStoredValue
    | IntegrationSystem.FreedomPayKioskStoredValue
    | IntegrationSystem.Givex
    | IntegrationSystem.OloStoredValue
    | IntegrationSystem.ParPayStoredValue
    | IntegrationSystem.PaytronixGift
    | IntegrationSystem.PinataPayNativeStoredValue
    | IntegrationSystem.PinataPayStoredValue
    | IntegrationSystem.PinataStoredValue
    | IntegrationSystem.StarbucksStoredValue
    | IntegrationSystem.Tcc
    | IntegrationSystem.Valutec
    | IntegrationSystem.WorldpayStoredValue;

  export type SupplementaryMenuSource = IntegrationSystem.Sprinkles;

  export type TableTracker =
    | IntegrationSystem.LrsTableTracker
    | IntegrationSystem.PinataTableTracker
    | IntegrationSystem.Jtech;
}

export { IntegrationSystem };
